export default __webpack_public_path__ + "static/umami-cover-bg-6e1074658de7f9cf503aaf7b272eaf12.png";